import type { ContactResult, Outcome } from './api'

/**
 * The words for a disposition's contact result and outcome — what the agent
 * picks on the case page, and what Visit review shows a manager afterwards.
 */
export const CONTACT_RESULTS: { value: ContactResult; label: string }[] = [
  { value: 'CONNECTED',          label: 'Connected' },
  { value: 'NO_ANSWER',          label: 'No answer' },
  { value: 'BUSY',               label: 'Busy' },
  { value: 'SWITCHED_OFF',       label: 'Switched off' },
  { value: 'CALLBACK_REQUESTED', label: 'Callback' },
  { value: 'WRONG_NUMBER',       label: 'Wrong no.' },
  { value: 'INVALID_NUMBER',     label: 'Invalid no.' },
  { value: 'CUSTOMER_DISCONNECTED', label: 'Disconnected (CDC)' },
  { value: 'PERMANENT_NON_CONTACTABLE', label: 'Non-contactable (PNC)' },
]

export const OUTCOMES: { value: Outcome; label: string; promise?: boolean }[] = [
  { value: 'PROMISE_TO_PAY',      label: 'Promise to pay', promise: true },
  { value: 'PARTIAL_PROMISE',     label: 'Partial promise', promise: true },
  { value: 'ALREADY_PAID',        label: 'Already paid' },
  { value: 'REFUSAL',             label: 'Refusal' },
  { value: 'DISPUTE',             label: 'Dispute' },
  { value: 'NEGOTIATION',         label: 'Negotiation' },
  { value: 'NOT_REACHABLE',       label: 'Not reachable' },
  { value: 'THIRD_PARTY_RESPONSE',label: 'Third party' },
  { value: 'NO_RESPONSE_NEEDED',  label: 'No response needed' },
  { value: 'DECEASED_REPORTED',   label: 'Death reported' },
  { value: 'CLOSURE_REQUEST',     label: 'Foreclosure request (FC)' },
  { value: 'SETTLEMENT_REQUEST',  label: 'Settlement / waiver (RSW)' },
  { value: 'BROKEN_PTP',          label: 'Broken PTP' },
]
